import { ɵɵdefineInjectable, Injectable, Pipe, NgModule } from '@angular/core';
import n2words from 'n2words';

class NgxNumToWordsService {
    inWords(value, lang) {
        return n2words(value, { lang });
    }
}
NgxNumToWordsService.ɵprov = ɵɵdefineInjectable({ factory: function NgxNumToWordsService_Factory() { return new NgxNumToWordsService(); }, token: NgxNumToWordsService, providedIn: "root" });
NgxNumToWordsService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];

class InWordsPipe {
    transform(value, lang) {
        return n2words(value, { lang });
    }
}
InWordsPipe.decorators = [
    { type: Pipe, args: [{
                name: 'inWords'
            },] }
];

class NgxNumToWordsModule {
}
NgxNumToWordsModule.decorators = [
    { type: NgModule, args: [{
                declarations: [InWordsPipe],
                imports: [],
                exports: [InWordsPipe]
            },] }
];

/*
 * Public API Surface of ngx-num-to-words
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InWordsPipe, NgxNumToWordsModule, NgxNumToWordsService };
